import { Layout } from 'components/atoms'
import { InputBuild, SelectBuild } from 'components/molecules'
import { AgentResponseDTO, LocationsDTO } from 'models'
import React, { useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { FormCreditorValue } from './form'
import { ViewCreditorFormProps } from './interfaces'

const ViewCreditorForm: React.FC = () => {
    const { register, watch } = useFormContext<{
        creditor: ViewCreditorFormProps
    }>();

    const [location] = useState<LocationsDTO[]>([]);

    // 1. Tente capturar a razão social de diferentes campos possíveis
    // O watch('creditor') traz o objeto completo do credor carregado no reload
    const creditorData = watch('creditor') as any;

    const currentCnpj = creditorData?.cnpj;
    // Tenta 'razaoSocial', se não houver, tenta 'nome', se não, usa 'Agente Financeiro'
    const currentRazaoSocial = creditorData?.razaoSocial || creditorData?.nome;

    const agentesFake = useMemo(() => {
        if (!currentCnpj) return [];
        return [
            { 
                cnpj: currentCnpj, 
                razaoSocial: currentRazaoSocial || 'Agente Financeiro' 
            }
        ] as unknown as AgentResponseDTO[];
    }, [currentCnpj, currentRazaoSocial]);

    const form = useMemo(
        () => FormCreditorValue(location, agentesFake),
        [location, agentesFake]
    );

    return (
        <Layout full type="container" display="grid" gap={8}>
            <Layout type="row" gutter={{ y: 1.5 }}>
                {form.map(({ layout, input, select }, key) => (
                    <Layout {...layout} key={key}>
                        {select ? (
                            <SelectBuild
                                {...select}
                                isLoading={false}
                                {...register(`creditor.${select.id}`)}
                                // Cast para evitar erro ts(2352) e garantir o valor na tela
                                value={(watch(`creditor.${select.id}`) as any) as string}
                                isDisable={true}
                                options={select.options}
                            />
                        ) : (
                            input && (
                                <InputBuild
                                    {...input}
                                    {...register(`creditor.${input.id}`)}
                                    value={(watch(`creditor.${input.id}`) as any) as string}
                                    isDisable={true}
                                />
                            )
                        )}
                    </Layout>
                ))}
            </Layout>
        </Layout>
    );
}

export default ViewCreditorForm